<div class="container">
    <div class="titre">Les spécialistes de l'assurance implantés à Auxerre</div>
    <div class="blabla">La Maison de l'Assurance du Centre Est, située à Auxerre, est une entreprise qui compare pour vous toutes les offres des différentes compagnies d'assurance 
        afin de trouver celle qui s'adapte le mieux à votre budget et à vos critères.
        Vous souhaitez trouver une assurance automobile, habitation, santé, professionnelle, décès et même une assurance prêt ? Votre courtier d'assurance est là pour vous trouver la meilleure solution.</div>
    <div class="bouton" (click)="nav.nav('contact')">Nous solliciter</div>

</div>